<div class="cards-grid grid grid-cols-1 md:grid-cols-2 gap-2 w-full">
  <p-card class="w-full h-full" styleClass="card-col">
    <div class="card-inner flex flex-col justify-between">
      <app-dados-localizacao-demanda
        [showMapa]="true"
        [showTipoObra]="true"
        [mapaAlturaDinamica]="true"
        [tipoObraId]="state.tipoObraId()"
        [dadosLocalizacao]="state.dadosLocalizacao()"
      />
      <div class="flex justify-end mt-2 shrink-0">
        <p-button styleClass="btn-red" label="Editar" [disabled]="uploadEmAndamento()" (onClick)="onEditLocalizacao()"
            (keydown.enter)="$event.preventDefault(); onEditLocalizacao()"
            (keydown.space)="$event.preventDefault(); onEditLocalizacao()">
          <app-icon-pencil/>
        </p-button>
      </div>
    </div>
  </p-card>

  <p-card class="w-full h-full" styleClass="card-col">
    <div class="card-inner flex flex-col">
      <div class="card-content flex-1">
        <app-form-anexos-demanda
          [initialAnexos]="state.anexos()"
          (anexosChange)="onAnexosChange($event)"
          (uploadStatusChange)="onUploadStatusChange($event)"
        />
      </div>

      <div class="flex justify-end gap-2 mt-4 shrink-0">
        <p-button styleClass="btn-outlined" label="Voltar" [disabled]="uploadEmAndamento()" (onClick)="onVoltar()"
            (keydown.enter)="$event.preventDefault(); onVoltar()"
            (keydown.space)="$event.preventDefault(); onVoltar()">
          <app-icon-bold-arrow-left color="currentColor" size="21"/>
        </p-button>
        <p-button styleClass="btn-red" label="Criar Demanda"
                  (onClick)="onCriarDemanda()"
                  (keydown.enter)="$event.preventDefault(); onCriarDemanda()"
                  (keydown.space)="$event.preventDefault(); onCriarDemanda()" [disabled]="uploadEmAndamento() || submitting"
                  [loading]="submitting">
          <app-icon-checked-circle [hidden]="submitting" color="currentColor" size="16"/>
        </p-button>
      </div>
    </div>
  </p-card>
</div>


@if (showConfirmarDialog()) {
  <app-dialog
    [(visible)]="showConfirmarDialog"
    [closable]="false"
    [headerTitle]="'Confirmar Dados da Demanda'"
    width="60vw"
  >
    <div class="flex flex-col gap-2">
      <app-dados-localizacao-demanda
        [showMapa]="true"
        [showTipoObra]="true"
        [showData]="false"
        [tipoObraId]="state.tipoObraId()"
        [dadosLocalizacao]="state.dadosLocalizacao()"
      />

      @if (descricaoForm) {
        <app-form-descricao-demanda [form]="descricaoForm" [editMode]="false"/>
      }

      <app-form-anexos-demanda [editMode]="false" [viewAnexos]="state.anexos()"/>
    </div>

    <div class="flex justify-end gap-2" footer>
      <p-button [label]="'Continuar editando'" styleClass="btn-outlined"
                [disabled]="uploadEmAndamento() || submitting"
                (onClick)="showConfirmarDialog.set(false)"
                (keydown.enter)="$event.preventDefault(); showConfirmarDialog.set(false)"
                (keydown.space)="$event.preventDefault(); showConfirmarDialog.set(false)">
        <app-icon-pencil color="currentColor"/>
      </p-button>
      <p-button
        label="Salvar"
        styleClass="btn-red"
        [disabled]="uploadEmAndamento() || submitting"
        [loading]="submitting"
        (onClick)="onConfirmarSubmit()"
        (keydown.enter)="$event.preventDefault(); onConfirmarSubmit()"
        (keydown.space)="$event.preventDefault(); onConfirmarSubmit()"
      >
        <app-icon-bold-ram-2 [hidden]="submitting" color="currentColor"/>
      </p-button>
    </div>
  </app-dialog>

}
